import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { message, Pagination } from 'antd'
import { getUsers, deleteUser } from '../../Web Apis/webApis'
import Load from '../Load/Load'
import { AiFillEdit, AiOutlineEye, AiFillDelete } from "react-icons/ai";
import { FaSearch, FaUserPlus, FaUsers } from 'react-icons/fa';
import { MdAdminPanelSettings, MdPerson } from 'react-icons/md';
import CreateAdmin from './CreateAdmin'
import ViewAdmin from './ViewAdmin'
import EditAdmins from './EditAdmins'
import noProfile from '../../Images/noProfile.jpg'

const Admin = () => {

    const [admin, setAdmin] = useState([])
    const [loading, setLoading] = useState(false)
    const [showAddAdmin, setShowAddAdmin] = useState(false)
    const [showViewAdmin, setShowViewAdmin] = useState(false)
    const [showEditAdmin, setShowEditAdmin] = useState(false)
    const [showDeleteAdmin, setShowDeleteAdmin] = useState(false)
    const [action, setAction] = useState(false);
    const [selectedAdmin, setSelectedAdmin] = useState({});

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // Calculate the current items for the page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;


    const filterAdmins = admin.filter((user) => {
        const query = searchQuery.toLowerCase();
        return (
            (user.name && user.name.toLowerCase().includes(query)) ||
            (user.email && user.email.toLowerCase().includes(query)) ||
            (user.firebaseId && user.firebaseId.toLowerCase().includes(query)) ||
            (user.provider && user.provider.toLowerCase().includes(query))
        )
    })

    const currentAdmins = filterAdmins.slice(indexOfFirstItem, indexOfLastItem);

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1)
    }


    const getUserProfiles = async () => {
        try {
            setLoading(true)
            const response = await getUsers()
            if (response?.data?.success) {

                const reverseData = [...response?.data?.data].reverse();


                setAdmin(reverseData)

            }
        } catch (error) {
            console.log("Admin fetch error", error.message)
            if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
                // Handle internet disconnection
                return;
            }
            // Handle specific error cases
            if (error?.response?.status === 401) {
                window.alert("Your account is logged in to another device, please login again !")
                localStorage.removeItem('token');
                window.location.href = "/login"
            }
            if (error?.response?.status === 500) {
                message.error("Server not responding")
            } else {
                return;
            }

        } finally {
            setLoading(false)
        }
    }

    const deleteUserProfile = async () => {
        if (!selectedAdmin) return;
        try {
            setLoading(true)
            const response = await deleteUser(selectedAdmin._id)
            if (response?.data?.success) {
                message.success(response?.data?.message)
                setAction(!action);

                setShowDeleteAdmin(false)
            }
        } catch (error) {
            console.log("Error while delete admin profile", error.message)
            message.error(error?.response?.data?.message || "Error while delete user profile")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getUserProfiles();
    }, [action])

    // const handleCreateModalOpen = () => {
    //     setShowAddAdmin(true)
    // }

    const handleDetailsModalOpen = (admins) => {
        setSelectedAdmin(admins);
        setShowViewAdmin(true)

    }

    const handleUpdateModalOpen = (admins) => {
        setSelectedAdmin(admins)
        setShowEditAdmin(true)
    }

    // const handleDeleteSubContracter = (admins) => {
    //     setSelectedAdmin(admins)
    //     setShowDeleteAdmin(true)
    // }



    return (
        <div className="p-6 mt-16">
            {/* Header Section with Add Button */}
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h2 className="text-3xl font-bold text-gray-800">User Management</h2>
                    <p className="text-gray-600 mt-1">Manage user accounts and permissions</p>
                </div>
                {/* <div className="flex gap-3">
                    <button
                        onClick={() => setShowAddAdmin(true)}
                        className="bg-gradient-to-r from-green-600 to-green-700 text-white px-6 py-3 rounded-lg hover:from-green-700 hover:to-green-800 transition-all duration-200 flex items-center gap-3 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                    >
                        <FaUserPlus className="text-lg" />
                        <span className="font-medium">Add New User</span>
                    </button>
                </div> */}
            </div>

            {/* Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white p-4 rounded-lg shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-blue-100 text-sm">Total Users</p>
                            <p className="text-2xl font-bold">{admin.length}</p>
                        </div>
                        <div className="text-blue-200 text-2xl">
                            <FaUsers />
                        </div>
                    </div>
                </div>
                <div className="bg-gradient-to-r from-green-500 to-green-600 text-white p-4 rounded-lg shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-green-100 text-sm">Admin Users</p>
                            <p className="text-2xl font-bold">{admin.filter(user => user.isAdmin).length}</p>
                        </div>
                        <div className="text-green-200 text-2xl">
                            <MdAdminPanelSettings />
                        </div>
                    </div>
                </div>
                <div className="bg-gradient-to-r from-purple-500 to-purple-600 text-white p-4 rounded-lg shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-purple-100 text-sm">Regular Users</p>
                            <p className="text-2xl font-bold">{admin.filter(user => !user.isAdmin).length}</p>
                        </div>
                        <div className="text-purple-200 text-2xl">
                            <MdPerson />
                        </div>
                    </div>
                </div>
                <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-white p-4 rounded-lg shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-orange-100 text-sm">Active Today</p>
                            <p className="text-2xl font-bold">{Math.floor(admin.length * 0.7)}</p>
                        </div>
                        <div className="text-orange-200 text-2xl">
                            <AiOutlineEye />
                        </div>
                    </div>
                </div>
            </div>

            {/* Search Bar */}
            <div className="bg-white p-4 rounded-lg shadow-md mb-6">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4 flex-1">
                        <div className="relative flex-1 max-w-md">
                            <FaSearch className="absolute left-3 top-3 text-gray-400" />
                            <input
                                type="text"
                                placeholder="Search users by name, email, or provider..."
                                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                onChange={handleSearch}
                                value={searchQuery}
                            />
                        </div>
                        <div className="text-sm text-gray-600">
                            Showing {currentAdmins.length} of {admin.length} users
                        </div>
                    </div>
                </div>
            </div>


            {/* Enhanced Users Table */}
            <div className="bg-white shadow-xl rounded-xl overflow-hidden border border-gray-200">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gradient-to-r from-gray-50 to-gray-100">
                            <tr>
                                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">#</th>
                                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Profile</th>
                                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">User Details</th>
                                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Provider</th>
                                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Firebase ID</th>
                                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Role</th>
                                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {currentAdmins?.length > 0 ? (
                                currentAdmins?.map((admins, index) => (
                                    <tr key={admins._id || admins.id} className="hover:bg-gradient-to-r hover:from-blue-50 hover:to-transparent transition-all duration-200 group">
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="flex items-center">
                                                <span className="inline-flex items-center justify-center w-8 h-8 bg-gray-100 text-gray-600 text-sm font-medium rounded-full group-hover:bg-blue-100 group-hover:text-blue-600 transition-colors">
                                                    {(currentPage - 1) * itemsPerPage + index + 1}
                                                </span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="flex items-center">
                                                <div className="relative">
                                                    {admins?.profileImageUrl ? (
                                                        <img
                                                            src={admins?.profileImageUrl}
                                                            alt="user profile"
                                                            className="h-12 w-12 object-cover rounded-full border-2 border-gray-200 shadow-sm"
                                                        />
                                                    ) : (
                                                        <img
                                                            src={noProfile}
                                                            alt="default profile"
                                                            className="h-12 w-12 object-cover rounded-full border-2 border-gray-200 shadow-sm"
                                                        />
                                                    )}
                                                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 rounded-full transition-all duration-200"></div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="max-w-xs">
                                                <div className="text-sm font-semibold text-gray-900 truncate group-hover:text-blue-600 transition-colors" title={admins.name}>
                                                    {admins.name || 'N/A'}
                                                </div>
                                                <div className="text-sm text-gray-500 truncate mt-1" title={admins.email}>
                                                    {admins.email}
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <span className={`inline-flex items-center px-3 py-1 text-xs font-semibold rounded-full ${
                                                admins.provider === 'google' ? 'bg-red-100 text-red-800 border border-red-200' :
                                                admins.provider === 'firebase' ? 'bg-orange-100 text-orange-800 border border-orange-200' :
                                                'bg-gray-100 text-gray-800 border border-gray-200'
                                            }`}>
                                                {admins.provider || 'N/A'}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900 font-mono">
                                                {admins.firebaseId ? `${admins.firebaseId.substring(0, 8)}...` : 'N/A'}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <span className={`inline-flex items-center px-3 py-1 text-xs font-semibold rounded-full ${
                                                admins.isAdmin
                                                    ? 'bg-blue-100 text-blue-800 border border-blue-200'
                                                    : 'bg-gray-100 text-gray-800 border border-gray-200'
                                            }`}>
                                                {admins.isAdmin ? (
                                                    <>
                                                        <MdAdminPanelSettings className="w-3 h-3 mr-1" />
                                                        Admin
                                                    </>
                                                ) : (
                                                    <>
                                                        <MdPerson className="w-3 h-3 mr-1" />
                                                        User
                                                    </>
                                                )}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="flex items-center space-x-1">
                                                <button
                                                    onClick={() => handleDetailsModalOpen(admins)}
                                                    className="inline-flex items-center justify-center w-8 h-8 bg-blue-50 text-blue-600 hover:bg-blue-100 hover:text-blue-700 rounded-lg transition-all duration-200 group"
                                                    title="View Details"
                                                >
                                                    <AiOutlineEye className="text-sm" />
                                                </button>
                                                <button
                                                    onClick={() => handleUpdateModalOpen(admins)}
                                                    className="inline-flex items-center justify-center w-8 h-8 bg-green-50 text-green-600 hover:bg-green-100 hover:text-green-700 rounded-lg transition-all duration-200 group"
                                                    title="Edit User"
                                                >
                                                    <AiFillEdit className="text-sm" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="px-6 py-12 text-center">
                                        <div className="flex flex-col items-center justify-center">
                                            <FaUsers className="text-gray-400 text-4xl mb-4" />
                                            <p className="text-gray-500 text-lg font-medium">No users found</p>
                                            <p className="text-gray-400 text-sm">Try adjusting your search criteria</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination */}
            {admin.length > itemsPerPage && (
                <div className="flex justify-center mt-6">
                    <Pagination
                        current={currentPage}
                        total={admin.length}
                        pageSize={itemsPerPage}
                        onChange={handlePageChange}
                        showSizeChanger={false}
                        showQuickJumper
                        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} users`}
                    />
                </div>
            )}

            {loading && <Load />}

            {showAddAdmin && (
                <CreateAdmin
                    showAddAdmin={showAddAdmin}
                    setShowAddAdmin={setShowAddAdmin}
                    action={action}
                    setAction={setAction}
                />
            )}

            {showViewAdmin && (
                <ViewAdmin
                    showViewAdmin={showViewAdmin}
                    setShowViewAdmin={setShowViewAdmin}
                    selectedAdmin={selectedAdmin}
                />
            )}

            {showEditAdmin && (
                <EditAdmins
                    showEditAdmin={showEditAdmin}
                    setShowEditAdmin={setShowEditAdmin}
                    selectedAdmin={selectedAdmin}
                    action={action}
                    setAction={setAction}
                />
            )}

            {showDeleteAdmin && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" style={{ zIndex: 50 }}>
                    <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                        <h3 className="text-3xl font-bold mb-4 text-start">Confirm Delete</h3>
                        <p className="mb-4 text-start">Are you sure you want to delete this user profile ? </p>
                        <div className="flex justify-end gap-4">
                            <button onClick={() => { setShowDeleteAdmin(false) }} className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200">
                                Cancel
                            </button>
                            <button onClick={deleteUserProfile} className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200">
                                Delete
                            </button>
                        </div>
                    </div>
                    {loading && <Load />}
                </div>
            )}

        </div>
    )
}

export default Admin